<template>
  <div id="liquid_cooling" ref="contentRef">
    <div class="assets">
      <div
        class="asset"
        :style="{ 'flex-direction': shrink ? 'column' : 'row-reverse' }"
      >
        <img
          src="@/assets/service/computational_equipment_thumbnail.png"
          alt="computational equipment"
          class="thunbnail"
        />
        <div class="introduce">
          <div class="label">{{ $t("service.COMPUTATIONAL_EQUIPMENT") }}</div>
          <div class="options">
            <div class="option" v-for="(item, index) in 3" :key="index">
              <div class="icon">
                <img src="@/assets/product/correct.svg" alt="" />
              </div>
              <span>{{
                $t(`service.COMPUTATIONAL_EQUIPMENT_DESCRIPTION_${index}`)
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="asset"
        :style="{ 'flex-direction': shrink ? 'column' : 'row' }"
      >
        <img
          src="@/assets/service/domestic_data_centers_thumbnail.png"
          alt="domestic data centers"
          class="thunbnail"
        />
        <div class="introduce">
          <div class="label">{{ $t("service.DOMESTIC_DATA_CENTERS") }}</div>
          <div class="options">
            <div class="option" v-for="(item, index) in 4" :key="index">
              <div class="icon">
                <img src="@/assets/product/correct.svg" alt="" />
              </div>
              <span>{{
                $t(`service.DOMESTIC_DATA_CENTERS_DESCRIPTION_${index}`)
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="asset"
        :style="{ 'flex-direction': shrink ? 'column' : 'row-reverse' }"
      >
        <img
          src="@/assets/service/international_data_centers_thumbnail.png"
          alt="international data centers"
          class="thunbnail"
        />
        <div class="introduce">
          <div class="label">
            {{ $t("service.INTERNATIONAL_DATA_CENTERS") }}
          </div>
          <div class="options">
            <div class="option" v-for="(item, index) in 4" :key="index">
              <div class="icon">
                <img src="@/assets/product/correct.svg" alt="" />
              </div>
              <span>{{
                $t(`service.INTERNATIONAL_DATA_CENTERS_DESCRIPTION_${index}`)
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import provide_key from "@/constant/provide_key";
import { defineEmits, inject, onMounted, ref, defineExpose, watch, nextTick } from "vue";
import { useI18n } from "vue-i18n";
const emits = defineEmits(["height"]);
const { locale } = useI18n();
const contentRef = ref<null | HTMLElement>(null);

const shrink: boolean | undefined = inject(provide_key.SHRINK);

onMounted(() => {
  watch(
    () => locale.value,
    () => {
      if (contentRef.value) {
        nextTick(() => emits("height", contentRef.value?.offsetHeight))
      }
    },
    { immediate: true }
  );
});
</script>

<style lang="less" scoped>
#liquid_cooling {
  width: 100%;
  margin-bottom: 6rem;
  margin-top: 2rem;
  height: fit-content;

  .assets {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6rem;
    padding: 0 2rem;
    margin: 0 auto;
    max-width: var(--view-max-width);

    .asset {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2rem;
      color: #000;
      width: 100%;

      .thunbnail {
        height: 21rem;
        min-width: 30rem;
        overflow: hidden;
      }

      .introduce {
        max-width: 80%;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        .label {
          font-size: var(--label-title);
          font-weight: 600;
          overflow: hidden;
        }

        .options {
          display: flex;
          flex-direction: column;
          gap: 0.6rem;
          font-size: var(--label-description);

          .option {
            display: flex;
            gap: 12px;
            color: #4e4e4e;
            align-items: center;

            .icon {
              flex-shrink: 0;
              width: 1.5rem;

              img {
                width: 100%;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }
}
</style>